export enum LicenseChangeStatus {
  NEW = "NEW",
  TERMINATED = "TERMINATED",
  CHANGED = "CHANGED",
  QUANTITY_CHANGED = "QUANTITY_CHANGED",
}
